export const TIPS_TYPE = {
  PERSONAL: 'PERSONAL',
  COMMON: 'COMMON',
  COMMON_PRIORITY: 'COMMON_PRIORITY',
  MIXED: 'MIXED',
};
